import ProductFeedSelector from '../../ProductFeeds/ProductFeedSelector';
import SettingRow from '../../SettingRow/SettingRow';

// `name` is the stored slot key; only the label is shown.
const FEED_SLOTS = [
  { name: 'Recommended for you', label: 'Recommended for you' },
  { name: 'Promo', label: 'Promo' },
  { name: 'Current Cart Products', label: 'Current cart products' },
  { name: 'Browsing history', label: 'Browsing history' },
  { name: 'Notification', label: 'Notification system' },
];

const ProductFeedsSection = ({ accountId, domainId, getProductFeedId, onProductFeedChange }) => (
  <>
    {FEED_SLOTS.map(({ name, label }) => (
      <SettingRow key={name} label={label}>
        <ProductFeedSelector
          accountId={accountId}
          domainId={domainId}
          productFeedId={getProductFeedId(name)}
          onSelect={(id) => onProductFeedChange(name, id)}
          optional
          compact
        />
      </SettingRow>
    ))}
  </>
);

export default ProductFeedsSection;
